import {SET_TRACK_TABLE} from '../_CONSTANTS';

export const set_Track_Table = (table) => {
  return {
    type: SET_TRACK_TABLE,
    payload: table
  }
}
